import React from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import Header from './Components/Header';
import './Style.css';
import C from './Course/C';
import Howto from './Components/Howto';
import Tools from './Components/Tools';
import Footer from './Components/Footer';
import Paynow from './Components/Paynow';
import Home from './Components/Home/Home';
import Aboutus from './Components/Aboutus';
import Blogs from './Components/Blogs/Blogs';
import AISearch from './Components/AISearch';
import Signin from './Components/Sign/Signin';
import TryEditor from './Components/TryEditor';
import Course from './Components/Course/Course';
import WhiteBoard from './Components/WhiteBoard';
import Admin from './Components/AdminPannel/Admin';
import PdfDashboard from './Components/PdfDashboard';
import TypingMaster from './Components/TypingMaster';
import ViewBlogs from './Components/Blogs/ViewBlogs';
import Dashboard from './Components/Course/Dashboard';
import Result from './Components/ExerciseTest/Result';
import LoginAdmin from './Components/Login/LoginAdmin';
import Polices from './Components/ExerciseTest/Polices';
import Syllabus from './Components/ExerciseTest/Syllabus';
import QuizList from './Components/ExerciseTest/QuizList';
import ExamView from './Components/ExerciseTest/ExamView';
import StartQuiz from './Components/ExerciseTest/StartQuiz';
import PrivacyAndPolicy from './Components/PrivacyAndPolicy';
import TermAndCondition from './Components/TermAndCondition';
import ExamDetails from './Components/ExerciseTest/ExamDetails';
import ExerciseTest from './Components/ExerciseTest/ExerciseTest';
import Notification from './Components/ExerciseTest/Notification';
import PreviousYearQuiz from './Components/ExerciseTest/PreviousYearQuiz';
import DynamicDocx from './Components/DynamicDocx';
import SubHeader from './Components/SubHeader';
import ProtectedRoute from './Components/Course/ProtectedRoute';
import RemoveBg from './Components/RemoveBg';
import CTryEditor from './Components/CTryEditor';
import JsEditor from './Components/JsEditor';
import CssBoxShadowGenerate from './Components/CssBoxShadowGenerate';
// import JaiMataDiCreation from './Components/Shopping/JaiMataDiCreation';
// import ViewSarees from './Components/Shopping/ViewSarees';
// import Orders from './Components/Shopping/Orders';

const App = () => {
  return (
    <>
      <Router>
        <div className="subheader-wrapper">
          <SubHeader />
        </div>
        {/* <Header /> */}
        <Routes>
          <Route path='/' element={<Home />} />

          <Route path='/C/:id' element={<C />} />
          <Route path='/ai/:id' element={<C />} />
          <Route path='/css/:id' element={<C />} />
          <Route path='/php/:id' element={<C />} />
          <Route path='/dsa/:id' element={<C />} />
          <Route path='/java/:id' element={<C />} />
          <Route path='/dbms/:id' element={<C />} />
          <Route path='/html/:id' element={<C />} />
          <Route path='/CPlus/:id' element={<C />} />
          <Route path='/MySql/:id' element={<C />} />
          <Route path='/python/:id' element={<C />} />
          <Route path='/reactjs/:id' element={<C />} />
          <Route path='/computer/:id' element={<C />} />
          <Route path='/msoffice/:id' element={<C />} />
          <Route path='/bootstrap/:id' element={<C />} />
          <Route path='/javascript/:id' element={<C />} />
          <Route path='/spoken English/:id' element={<C />} />
          <Route path='/Digital Marketing/:id' element={<C />} />
          <Route path='/Computer Networking/:id' element={<C />} />

          <Route path='Result' element={<Result />} />
          <Route path='/tools' element={<Tools />} />
          <Route path='/blogs' element={<Blogs />} />
          <Route path='/paynow' element={<Paynow />} />
          <Route path='/Howto' element={<Howto />} />
          <Route path='Polices' element={<Polices />} />
          <Route path='/course' element={<Course />} />
          <Route path='/signin' element={<Signin />} />
          <Route path='/ExamView/:name' element={<ExamView />} />
          <Route path='/AISearch' element={<AISearch />} />
          <Route path='/Syllabus' element={<Syllabus />} />
          <Route path='/about-us' element={<Aboutus />} />
          <Route path='/login' element={<LoginAdmin />} />
          <Route path='/quiz-list' element={<QuizList />} />
          <Route path='/admin/admin' element={<Admin />} />
          <Route path='WhiteBoard' element={<WhiteBoard />} />
          <Route path='DynamicDocx' element={<DynamicDocx />} />
          <Route path='/TryEditor' element={<TryEditor />} />
          <Route path='/RemoveBg' element={<RemoveBg />} />
          <Route path='/CTryEditor' element={<CTryEditor />} />
          <Route path='/jsEditor' element={<JsEditor/>}/>
          <Route path='/CssBoxShadowGenerate' element={<CssBoxShadowGenerate/>}/>
          <Route
            path="/FullStackDashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route path='/ExamDetails' element={<ExamDetails />} />
          <Route path='/viewblog/:id' element={<ViewBlogs />} />
          <Route path='TypingMaster' element={<TypingMaster />} />
          <Route path='/Pdfdashboard' element={<PdfDashboard />} />
          <Route path='/Notification' element={<Notification />} />
          <Route path='/start-quiz/:type' element={<StartQuiz />} />
          <Route path='/ExerciseTest' element={<ExerciseTest />} />
          <Route path="privacy-policy" element={<PrivacyAndPolicy />} />
          <Route path='/PreviousYearQuiz' element={<PreviousYearQuiz />} />
          <Route path='terms-and-condition' element={<TermAndCondition />} />
          {/* <Route path='/Orders' element={<Orders/>}/> */}
          {/* <Route path='/JaiMataDiCreation' element={<JaiMataDiCreation/>}/> */}
          {/* <Routes path='/viewsarees/:id' element={<ViewSarees />} /> */}
        </Routes>
        <Footer />
      </Router>
    </>
  );
};

export default App;
